export default __webpack_public_path__ + "components/page-header/static/surf-forecast__logo--white-5c762b3a79792e95316cf6678f4e5247.png";